
import { defineComponent, ref, onMounted, computed, inject, watch } from "vue";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";

export default defineComponent({
  name: "IndustrySectors",
  components: {},
  props: {
    formDataTemp: {
      type: Object,
      required: true,
    },
    touchedParent: {
      type: Boolean,
      required: true,
    },
  },
  setup(props, { emit }) {
    const store = useStore();
    const industrySectors = computed(() => store.getters.industrySectorsGetter);
    let formData = ref<Record<string, unknown>>(props.formDataTemp);
    let selectedIndustrySectors = ref<Array<number>>([]);
    const isChecked = (id) => {
      return selectedIndustrySectors.value.some((sector) => sector == id);
    };
    const business = inject("business");
    watch(() => props.formDataTemp, (value) => {
      formData.value = {...value}
      if (value.industrySectors) {
        selectedIndustrySectors.value = [...value.industrySectors]
        emit("industrySectorsLength", selectedIndustrySectors.value.length);
      }
    });
    const touched = ref<boolean>(false);
    watch(
      () => props.touchedParent,
      (value) => {
        touched.value = value;
        if (value && !selectedIndustrySectors.value?.length)
          isAnyIndustrySectorSelected.value = true;
      }
    );
    const isAnyIndustrySectorSelected = ref<boolean>(false);
    const fieldChanged = () => {
      formData.value["industrySectors"] = selectedIndustrySectors.value
      emit("form-data", formData.value);
    };
    const addToIndustrySectors = (event) => {
      if (event.target.checked) {
        selectedIndustrySectors.value = [
          ...selectedIndustrySectors.value,
          event.target.dataset["id"],
        ];
      } else {
        selectedIndustrySectors.value = selectedIndustrySectors.value.filter(
          (i) => {
            return i != event.target.dataset["id"];
          }
        );
      }
      emit("industrySectorsLength", selectedIndustrySectors.value.length);
      isAnyIndustrySectorSelected.value = false;
      fieldChanged();
    };
    onMounted(() => {
      if (!industrySectors.value.length)
        store.dispatch(Actions.GET_INDUSTRY_SECTORS);
    });
    return {
      isAnyIndustrySectorSelected,
      formData,
      fieldChanged,
      industrySectors,
      addToIndustrySectors,
      isChecked,
    };
  },
});
